import { useState } from 'react';
import className from 'classnames/bind';
import { AnimatePresence, motion } from 'motion/react';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import { Button, MaterialLoader } from '@components';
import { TicketingFragment } from "@graphqlTypes";
import { useTicketing } from '../TicketingProvider';
import ButtonIcon from '@/assets/svg/external-arrow.svg';

import styles from './TicketingForm.module.scss';
const cx = className.bind(styles);

type TicketingFormProps = TicketingFragment['ticketingForm'];

export default function TicketingForm({ ctaLabel }: TicketingFormProps) {
  const { canSubmit, selectedSession, ticketsParsed, resetForm } = useTicketing();
  const [formError, setFormError] = useState<string | null>(null);
  const [formLoading, setFormLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    setFormLoading(true);
    e.preventDefault();
    const body = { session_id: selectedSession, tickets: ticketsParsed };
    const res = await fetch('/api/tickets/create-cart/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }).then(res => res.json());
    if (res.success && res.data?.checkout_url) {
      setTimeout(() => { window.location.href = res.data.checkout_url; }, 250);
    }
    else setFormError(res.message || 'There was an error processing your request. Please try again.');
    setFormLoading(false);
    resetForm();
  };

  return (
    <div className={cx(["ticketing-form", "col-12", "col-lg-7"])}>
      <form className={cx(["form"])} onSubmit={handleSubmit} data-gtm-section="ticketing-form">
        <AnimatePresence>
          {
            formLoading && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                key={'form-loader'}
                className={cx("form__loader")}
              >
                <MaterialLoader className={cx("form__loader__loader")} />
              </motion.div>
            )
          }
        </AnimatePresence>
        <StepOne />
        <StepTwo />
        <StepThree />
        <div className={cx("form__submit")}>
          <Button
            type='submit'
            disabled={!canSubmit}
            label={ctaLabel}
            icon={ButtonIcon}
          />
        </div>
      </form>
    </div>
  );
}